import styles from './NotesPopoverBody.module.css';

/**
 * NotesPopoverBody — the popover body shared between NotesControl (annotation
 * viewer / review viewer) and the progress grid's notes popover.
 *
 * Pure presentational: no API calls, no open/close state. The caller manages
 * the popover container (PopoverShell), the trigger, and any data wiring.
 */
export default function NotesPopoverBody({
    label,
    instructions = '',
    value = '',
    placeholder = '',
    maxLength,
    statusText = '',
    error = null,
    isReadOnly = false,
    showCounter = true,
    byUser = '',
    onChange,
    onBlur,
    titleId,
    instructionsId,
}) {
    const safeValue = typeof value === 'string' ? value : '';
    const counterText = Number.isFinite(maxLength)
        ? `${safeValue.length}/${maxLength}`
        : `${safeValue.length}`;

    return (
        <>
            <div className={styles.popoverHeader}>
                <div className={styles.titleRow}>
                    <div id={titleId} className={styles.title}>{label}</div>
                    {byUser ? (
                        <div className={styles.subtitle}>by {byUser}</div>
                    ) : null}
                </div>
                {statusText ? (
                    <div className={styles.status}>{statusText}</div>
                ) : null}
            </div>

            {instructions ? (
                <p
                    id={instructionsId}
                    className={styles.instructions}
                >
                    {instructions}
                </p>
            ) : null}

            <textarea
                className={styles.textarea}
                value={safeValue}
                onChange={isReadOnly ? undefined : onChange}
                onBlur={isReadOnly ? undefined : onBlur}
                placeholder={placeholder}
                maxLength={Number.isFinite(maxLength) ? maxLength : undefined}
                readOnly={isReadOnly}
                aria-label={label}
                aria-describedby={instructions ? instructionsId : undefined}
            />

            {(showCounter || error) ? (
                <div className={styles.footer}>
                    {showCounter ? (
                        <div className={styles.hint}>{counterText}</div>
                    ) : <span />}
                    {error ? (
                        <div className={styles.error} role="alert">{error}</div>
                    ) : null}
                </div>
            ) : null}
        </>
    );
}
